export interface IRequestVehicleTypes {
  orgId: number;
  rateType: number;
  orgVehicleTypeMapId: number;
  filterByType: number;
  employeeId: number;
  purchaseFunctionList: any[]
}

export class RequestVehicleTypes implements IRequestVehicleTypes {
  orgId: number;
  rateType: number;
  orgVehicleTypeMapId: number = 0;
  filterByType: number = 0;
  employeeId: number;
  purchaseFunctionList: any[] = [];
}

export interface IOrgUKRateVehicles {
  orgId: number;
  orgUKMileageVehicleTypes: IOrgUKMileageVehicleTypes[];
}

export class OrgUKRateVehicles implements IOrgUKRateVehicles {
  orgId: number;
  orgUKMileageVehicleTypes: IOrgUKMileageVehicleTypes[];
  constructor() {
  }
}


export interface IOrgUKMileageVehicleTypes {
  vehicleTypeId: number;
  vehicleSubTypeId: number;
  orgVehicleTypeMapId: number;
  derivedName: string;
  mileageRate: number;
  isActive: boolean;
  isDefault: number;
  isSelected: boolean;
  sequence: number;
  vehicleLabel: string;
  isMultiRange: boolean;
  concatVehicleTypeId: number;
  chargingType: number;
}


export class OrgUKMileageVehicleTypes implements IOrgUKMileageVehicleTypes {
  vehicleTypeId: number;
  vehicleSubTypeId: number;
  orgVehicleTypeMapId: number;
  derivedName: string;
  mileageRate: number;
  isActive: boolean = false;
  isDefault: number;
  isSelected: boolean;
  sequence: number;
  vehicleLabel: string;
  isMultiRange: boolean;
  concatVehicleTypeId: number;
  chargingType: number = 0;
  constructor() {
    //  this.orgId = orgId;
  }
}

export interface IOrgUKRateSelectedVehiclesResponse {
  resetDate: string;
  rateType: number;
  orgUKMileageVehicleTypesList: IOrgUKMileageVehicleTypes[];
}


export class OrgUKRateSelectedVehiclesResponse implements IOrgUKRateSelectedVehiclesResponse {
  resetDate: string;
  rateType: number;
  orgUKMileageVehicleTypesList: OrgUKMileageVehicleTypes[];
}


